import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from "@angular/common";
import { ApiService } from 'src/app/api.service';
// import { HeaderComponent } from '../header/header.component';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit {
  panelOpenState = false;
  screenwidth =null;
  shouldRun = true;
  public showSidebar = null;
  public activTab ;
  userInfo = JSON.parse(localStorage.getItem('User'));
  userName = this.userInfo.first_name;
  public changecolour = {boardMember:true, group:false, poll:false, result:false, manage:false,company:false,execute:false };
  public showTab = {boardMember:false, group:false, poll:false, result:false, manage:false,company:false,execute:false };
  constructor(private router:Router,location: Location,private _apiService: ApiService, private route: ActivatedRoute) {
    let userRole = this.userInfo.roles[0];
    if(userRole == 'root'){
      this.showTab = {boardMember:false, group:false, poll:false, result:false, manage:true,company:true,execute:false };
    }else if(userRole == 'user'){
      this.showTab = {boardMember:false, group:false, poll:false, result:true, manage:false,company:false,execute:false };
    }else if(userRole == 'admin' || userRole == 'manager'){
      this.showTab = {boardMember:true, group:true, poll:true, result:false, manage:true,company:false,execute:true };
    }

    this.activTab = location.path();
    var  finalTab= this.activTab.substr(this.activTab.lastIndexOf('/') + 1);
    var smsInfo = this.activTab.split('/');
    if(finalTab == 'board-member' && this.showTab.boardMember){
      this.router.navigate(['home/board-member']);
      this.changecolour = {boardMember:true, group:false, poll:false, result:false, manage:false,company:false,execute:false };
    }else if(finalTab == 'groups'  && this.showTab.group){
      this.router.navigate(['home/groups']);
      this.changecolour = {boardMember:false, group:true, poll:false, result:false, manage:false,company:false,execute:false };
    }else if(finalTab == 'new-poll'  && this.showTab.poll){
      this.router.navigate(['home/new-poll']);
      this.changecolour = {boardMember:false, group:false, poll:true, result:false, manage:false,company:false,execute:false };
    }else if(finalTab == 'result'  && this.showTab.result){
      this.router.navigate(['home/result']);
      this.changecolour = {boardMember:false, group:false, poll:false, result:true, manage:false,company:false,execute:false };
    }else if(finalTab == 'manage'  && this.showTab.manage){
      this.router.navigate(['home/manage']);
      this.changecolour = {boardMember:false, group:false, poll:false, result:false, manage:true,company:false,execute:false };
    }else if(finalTab == 'company'  && this.showTab.company){
      this.router.navigate(['home/company']);
      this.changecolour = {boardMember:false, group:false, poll:false, result:false, manage:false,company:true,execute:false };
    }else if(finalTab == 'execute'  && this.showTab.execute ){
      this.router.navigate(['home/execute']);
      this.changecolour = {boardMember:false, group:false, poll:false, result:false, manage:false,company:false,execute:true };
    }else if(userRole == 'admin' || userRole == 'manager'  && smsInfo[2] == 'sms-detail'){
      this.router.navigate([this.activTab]);
      this.changecolour = {boardMember:false, group:false, poll:false, result:false, manage:false,company:false,execute:true };
    }else if(userRole == 'admin'){
      this.router.navigate(['home/board-member']);
      this.changecolour = {boardMember:true, group:false, poll:false, result:false, manage:false,company:false,execute:false };
    }else if(userRole == 'root'){
      this.router.navigate(['home/company']);
      this.changecolour = {boardMember:false, group:false, poll:false, result:false, manage:false,company:true,execute:false };
    }else if(userRole == 'user'){
      this.router.navigate(['home/result']);
      this.changecolour = {boardMember:false, group:false, poll:false, result:true, manage:false,company:false,execute:false };
    }

   }

  ngOnInit(): void {
    this.screenwidth = screen.width;
    if(this.screenwidth < 500){
      this.showSidebar = false;
    }else{
      this.showSidebar = true;
    }
  }

  public onTabSelect(name) {
    if(name == 'boardMember'){
      this.router.navigate(['home/board-member']);
      this.changecolour = {boardMember:true, group:false, poll:false, result:false, manage:false,company:false,execute:false };
    }else if(name == 'group'){
      this.router.navigate(['home/groups']);
      this.changecolour = {boardMember:false, group:true, poll:false, result:false, manage:false,company:false,execute:false };
    }else if(name == 'poll'){
      this.router.navigate(['home/new-poll']);
      this.changecolour = {boardMember:false, group:false, poll:true, result:false, manage:false,company:false,execute:false };
    }else if(name == 'result'){
      this.router.navigate(['home/result']);
      this.changecolour = {boardMember:false, group:false, poll:false, result:true, manage:false,company:false,execute:false };
    }else if(name == 'manage'){
      this.router.navigate(['home/manage']);
      this.changecolour = {boardMember:false, group:false, poll:false, result:false, manage:true,company:false,execute:false };
    }else if(name == 'company'){
      this.router.navigate(['home/company']);
      this.changecolour = {boardMember:false, group:false, poll:false, result:false, manage:false,company:true,execute:false };
    }else if(name == 'execute'){
      this.router.navigate(['home/execute']);
      this.changecolour = {boardMember:false, group:false, poll:false, result:false, manage:false,company:false,execute:true };
    }
  }

  showHideSideBar(){
    this.showSidebar =!this.showSidebar;
  }

  logOut(){
    localStorage.clear();
    this.router.navigate(['login']);
  }

  copyToken(){
    let token = JSON.parse(localStorage.getItem('token'));
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = token;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

}